import { localeNamespace } from '@internal/utils/machine/i18n/Locale';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { translations } from './translations';

const translationsKeys = {
    English: translations.languageEnglish,
    Greek: translations.languageGreek,
    Romanian: translations.languageRomanian,
    Russian: translations.languageRussian,
    Dutch: translations.languageDutch,
    German: translations.languageGerman,
    Polish: translations.languagePolish,
    Bulgarian: translations.languageBulgarian,
    Hungarian: translations.languageHungarian,
    French: translations.languageFrench,
    Czech: translations.languageCzech,
    Croatian: translations.languageCroatian,
    Serbian: translations.languageSerbian,
    Italian: translations.languageItalian,
    Irish: translations.languageIrish,
    Spanish: translations.languageSpanish,
};

export const useTranslatedLanguages = () => {
    const { t } = useTranslation(localeNamespace.common);

    const translateLanguages = useCallback(
        (languages: string[]) =>
            languages.map(language => {
                const key =
                    translationsKeys[language as keyof typeof translationsKeys];
                return typeof key === 'string' ? t(key) : language;
            }),
        [t],
    );

    return { translateLanguages };
};
